<template>
  <div>
    <Intro
      :investor="investor"
      :editable="editable"
      :show-apply-actions="showApplyActions"
    />

    <div class="main-nav">
      <div class="container text-center">
        <ul v-if="tabsMode" class="nav nav-tabs">
          <li :class="{ active: selectedTab === TABS.OVERVIEW }">
            <a href @click.prevent="selectTab(TABS.OVERVIEW)">Overview</a>
          </li>
          <li
            v-if="user.isAdmin"
            :class="{ active: selectedTab === TABS.TEAM }"
          >
            <a href @click.prevent="selectTab(TABS.TEAM)">Team</a>
          </li>
          <li
            v-if="user.isAdmin"
            :class="{ active: selectedTab === TABS.LOGS }"
          >
            <a href @click.prevent="selectTab(TABS.LOGS)">Activity</a>
          </li>
        </ul>
        <ul v-if="!tabsMode" class="nav nav-tabs">
          <li :class="{ active: $route.name === overviewRoute.name }">
            <router-link :to="overviewRoute">
              Overview
            </router-link>
          </li>
          <li
            v-if="user.isAdmin"
            :class="{ active: $route.name === teamRoute.name }"
          >
            <router-link :to="teamRoute">
              Team
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="main-content">
      <div class="container">
        <router-view v-if="!tabsMode" />
        <template v-if="tabsMode">
          <Overview v-if="selectedTab === TABS.OVERVIEW" />
          <Team v-if="selectedTab === TABS.TEAM" />
          <Logs v-if="selectedTab === TABS.LOGS" />
        </template>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
// This component assumes that investor would be already fetched using
// $store.dispatch('investorDetails/fetch', { id })
// (which should be called by parent component)
import Intro from './Intro.vue'
import { Location } from 'vue-router'
import Overview from './Overview.vue'
import Team from './Team.vue'
import Logs from './Logs.vue'
import { mapState } from 'vuex'

const OVERVIEW = 'OVERVIEW'
const TEAM = 'TEAM'
const LOGS = 'LOG'

export default {
  components: { Intro, Logs, Overview, Team },
  props: {
    routes: { type: String, default: '' },
    editable: { type: Boolean, default: false },
    tabsMode: { type: Boolean, default: false },
    showApplyActions: { type: Boolean, default: true },
  },
  computed: {
    overviewRoute() {
      const params = { id: this.investor && this.investor.id }
      const name = {
        admin: 'adminInvestorEditor',
        public: 'publicInvestorProfile',
      }[this.routes]
      return { name, params }
    },

    teamRoute() {
      const params = { id: this.investor && this.investor.id }
      const name = {
        admin: 'adminInvestorEditorTeam',
        public: 'publicInvestorProfileTeam',
      }[this.routes]
      return { name, params }
    },

    ...mapState({
      investor: (state) => state.investorProfile.investor,
      user: (state) => state.user.data,
    }),
  },
  data() {
    return {
      TABS: { OVERVIEW, TEAM },
      selectedTab: OVERVIEW,
    }
  },
  methods: {
    selectTab(tab) {
      this.selectedTab = tab
    },
  },
}
</script>
